import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import calendericon from "../assets/auth/calendericon.svg";
import React, { useEffect, useState, useMemo, useRef } from "react";
import TabComponent from "./tabs/tab";
import FaxTable from "./faxtable";
import EmailTable from "./emailtable";
import VoiceMailTable from "./voicemailtable";
import { styled } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { reseticongray } from "../utils/svgs/svgcode";
import { externalapi } from "../api/externalapi";
import { leftarrow, rightarrow } from "../colorcoding/svg/iconsvg";
import api from "../api/api";
import { actionDropDownCalenderIcon } from "../landingscreen/modals/svgs";
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import Messaging from "./messaging";
import SendFaxModal from "./modals/sendfax";
import WebRequestsTable from "./webrequesttable";
import { getPracticeId, practiceShortName } from "../config/practice";
import { communicationTabs } from "./communicationTabs";
import { formatFaxRows, listAllFaxes, listDeletedFaxes, listFaxes } from "./faxApi";
import { faxMatchesSearch } from "./faxAi";

const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
  // Change selected date color
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: "#1D2951",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1D2951", // Keep the same color on hover
    },
  },
}));

// `embedded` (the unified Inbox, src/inbox/InboxPage.jsx): one queue of this
// page -- `initialTab` (0 Fax, 1 Email, 2 Voice mail) -- inside the Inbox's
// own layout: no side-nav wrapper, no tab row, the tab's controls unchanged.
// Without it (/fax): exactly as before.
const Fax = ({ embedded = false, initialTab = null }) => {
  // Per-practice tab list (communicationTabs.js); 9928 keeps all five.
  const tabs = communicationTabs();
  const firstTab = tabs[0].id;
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(initialTab ?? firstTab);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: dayjs(),
    endDate: dayjs(),
  });
  const [voicemails, setVoicemails] = useState([]);
  const [fax, setFax] = useState([]);
  // Fax work (faxWork.js): the provider choices and whether v2 tracks work.
  const [faxProviders, setFaxProviders] = useState([]);
  const [faxWorkAvailable, setFaxWorkAvailable] = useState(false);
  // Assignee (owner 10-13 "user buckets"): who a fax can be assigned to, whether
  // this login may assign, and its own id ("Assigned to me").
  const [faxAssign, setFaxAssign] = useState({ available: false, staff: [], canAssign: false, me: null });
  // The Deleted view (faxWork.js, owner 10-12): read only when it is opened.
  const [deletedFax, setDeletedFax] = useState([]);
  const [deletedDays, setDeletedDays] = useState(7);
  const [deletedLoaded, setDeletedLoaded] = useState(false);
  // "All (30 days)" (owner 10-22): open + done + deleted, provider-filtered by
  // v2 GET fax/all; read only when opened. counts = the window's per provider.
  const [all30Fax, setAll30Fax] = useState([]);
  const [all30Counts, setAll30Counts] = useState(null);
  const [all30Loaded, setAll30Loaded] = useState(false);
  const all30ProviderRef = useRef("all");
  const [openSendFax, setOpenSendFax] = useState(false);
  const [emails, setEmails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const practiseid = getPracticeId();

  const calendarRef = useRef(null);
  const calendarButtonRef = useRef(null);

  // Fetch Emails
  const fetchemails = async (startDate = null, endDate = null, search = "") => {
    try {
      setLoading(true);
      const payload = {
        startDate: startDate || dayjs().format("YYYY-MM-DD"),
        endDate: endDate || dayjs().format("YYYY-MM-DD"),
        recordSearch: search.trim(),
      };
      const response = await api.post(
        `/v1/${practiseid}/email/get-list`,
        payload,
      );
      if (response.status === 200) {
        setEmails(response.data || []);
      } else setEmails([]);
    } catch {
      setEmails([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Voicemails
  const fetchVoicemails = async (isblock) => {
    try {
      if (!isblock) {
        setLoading(true);
      }
      const extensionIds = [
        "62906620031",
        "62906621031",
        "348669030",
        "62906617031",
      ];
      const results = await Promise.allSettled(
        extensionIds.map((id) =>
          externalapi.post("/ringcentral/voice/getlist/", { extensionid: id }),
        ),
      );
      const allRecords = results.flatMap((res) =>
        res.status === "fulfilled" && res.value.status === 200
          ? res.value.data.data.records || []
          : [],
      );
      allRecords.sort(
        (a, b) => new Date(b.creationTime) - new Date(a.creationTime),
      );
      setVoicemails(allRecords);
    } catch {
      setVoicemails([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Fax
  const fetchFax = async (isblock) => {
    try {
      if (!isblock) {
        setLoading(true);
      }
      // v2 GET /v1/{pid}/fax/get-list, pinned (faxApi.js).
      const response = await listFaxes();
      // if(response.status){

      //       setFax(response?.data||[]);
      // }else{
      //   setFax([])
      // }
      if (response.status === 200) {
        // the RingCentral record flattened over the row; faxid = the row id
        // (faxApi.js formatFaxRows)
        const formatted = formatFaxRows(response?.data);

        setFax(formatted);
        setFaxProviders(Array.isArray(response?.fax_providers) ? response.fax_providers : []);
        setFaxWorkAvailable(response?.fax_work_available === true);
        setFaxAssign({
          available: response?.fax_assign_available === true,
          staff: Array.isArray(response?.fax_staff) ? response.fax_staff : [],
          canAssign: response?.fax_can_assign === true,
          me: response?.fax_me ?? null,
        });
      } else {
        setFax([]);
      }
    } catch {
      // A silent re-read (after refresh/delete, or the AI poll in
      // faxtable.jsx) that fails keeps the list on screen.
      if (!isblock) setFax([]);
    } finally {
      setLoading(false);
    }
  };

  // Deleted faxes received in the last `days` (v2 GET fax/deleted). A failed
  // silent re-read keeps the rows on screen.
  const fetchDeletedFax = async (days = deletedDays, isblock = false) => {
    try {
      if (!isblock) setLoading(true);
      const response = await listDeletedFaxes(days);
      if (response?.status === 200) {
        setDeletedFax(formatFaxRows(response?.data));
        setDeletedDays(Number(response?.days) || days);
        setDeletedLoaded(true);
      } else if (!isblock) setDeletedFax([]);
    } catch {
      if (!isblock) setDeletedFax([]);
    } finally {
      setLoading(false);
    }
  };

  // Every fax of the last 30 days for `provider` (v2 GET fax/all). A failed
  // silent re-read keeps the rows on screen; an answer for an older pick is
  // dropped.
  const fetchAll30Fax = async (provider = all30ProviderRef.current, isblock = false) => {
    all30ProviderRef.current = provider || "all";
    const asked = all30ProviderRef.current;
    try {
      if (!isblock) setLoading(true);
      const response = await listAllFaxes(30, asked);
      if (asked !== all30ProviderRef.current) return;
      if (response?.status === 200) {
        setAll30Fax(formatFaxRows(response?.data));
        setAll30Counts(response?.provider_counts && typeof response.provider_counts === "object" ? response.provider_counts : {});
        setAll30Loaded(true);
      } else if (!isblock) {
        setAll30Fax([]);
        setAll30Counts(null);
      }
    } catch {
      if (!isblock && asked === all30ProviderRef.current) {
        setAll30Fax([]);
        setAll30Counts(null);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on tab change
  useEffect(() => {
    document.title = `${practiceShortName()} - ${embedded ? "Inbox" : "Communication"}`;
    setSearchTerm("");
    setSelectedDate(null);
    if (selectedTab === 3 || selectedTab === 4) {
      // Messaging / Appt Requests - components fetch their own data
    } else if (selectedTab === 1) fetchemails();
    else if (selectedTab === 2) fetchVoicemails();
    else if (selectedTab === 0) fetchFax();
  }, [selectedTab]);

  // Refetch Emails when date or searchTerm changes
  useEffect(() => {
    if (selectedTab === 1) {
      fetchemails(
        dateRange.startDate.format("YYYY-MM-DD"),
        dateRange.endDate.format("YYYY-MM-DD"),
        searchTerm,
      );
    }
  }, [selectedTab, dateRange, searchTerm]);

  // Filtered Voicemails
  const filteredVoicemails = useMemo(() => {
    let data = [...voicemails];
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      data = data.filter(
        (vm) =>
          vm.from?.phoneNumber?.toLowerCase().includes(term) ||
          vm.from?.name?.toLowerCase().includes(term),
      );
    }
    if (selectedDate) {
      data = data.filter((vm) =>
        dayjs(vm.creationTime).isSame(selectedDate, "day"),
      );
    }
    return data;
  }, [voicemails, searchTerm, selectedDate]);

  // Filtered Fax
  const filteredFax = useMemo(() => {
    let data = [...fax];
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      // number, caller-ID name, the AI's sender and label, subject (faxAi.js)
      data = data.filter((fx) => faxMatchesSearch(fx, term));
    }
    if (selectedDate) {
      data = data.filter((fx) =>
        dayjs(fx.creationTime).isSame(selectedDate, "day"),
      );
    }
    return data;
  }, [fax, searchTerm, selectedDate]);

  const filteredDeletedFax = useMemo(() => {
    let data = [...deletedFax];
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      data = data.filter((fx) => faxMatchesSearch(fx, term));
    }
    if (selectedDate) {
      data = data.filter((fx) => dayjs(fx.creationTime).isSame(selectedDate, "day"));
    }
    return data;
  }, [deletedFax, searchTerm, selectedDate]);

  const filteredAll30Fax = useMemo(() => {
    let data = [...all30Fax];
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      data = data.filter((fx) => faxMatchesSearch(fx, term));
    }
    if (selectedDate) {
      data = data.filter((fx) => dayjs(fx.creationTime).isSame(selectedDate, "day"));
    }
    return data;
  }, [all30Fax, searchTerm, selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setIsCalendarOpen(false);
  };
  const clearDateFilter = () => setSelectedDate(null);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        calendarButtonRef.current &&
        !calendarButtonRef.current.contains(event.target)
      ) {
        setIsCalendarOpen(false);
      }
    };
    if (isCalendarOpen)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isCalendarOpen]);
  const handlePrevDate = (e) => {
    e.stopPropagation(); // don’t open calendar
    setSelectedDate((prev) =>
      prev ? prev.subtract(1, "day") : dayjs().subtract(1, "day"),
    );
  };

  const handleNextDate = (e) => {
    e.stopPropagation(); // don’t open calendar
    setSelectedDate((prev) =>
      prev ? prev.add(1, "day") : dayjs().add(1, "day"),
    );
  };

  // The Inbox renders the page inside its own layout.
  const Shell = embedded ? React.Fragment : SideNavLayout;
  const inboxFax = embedded && selectedTab === 0;

  return (
    <div className="h-full">
      {selectedTab === 3 && (
        <style>{`
          body { overflow: hidden !important; }
          [style*="min-height: 100vh"] { height: 100vh !important; overflow: hidden !important; }
        `}</style>
      )}
      <Shell>
        {/* One tight row (owner 10-13, OSA staff: "Lot of blank unused space at
            the top ... everything moved up"): the tabs, the date (‹ day ›),
            search + Reset, and Send Fax at the far right. Messaging / Appt
            Requests keep their own controls, so only the tabs show there. */}
        {/* The unified Inbox's Faxes queue: FaxTable shows the search, the day and
            Send Fax in its own organised bar (inboxStyle); everything else as before. */}
        {!inboxFax && (
        <div className="mb-2 flex w-full flex-wrap items-center gap-2" data-testid="comm-toolbar">
          {!embedded && <TabComponent tabs={tabs} selectedTab={selectedTab} onSelectTab={setSelectedTab} />}
          {selectedTab !== 3 && selectedTab !== 4 && (
            <div className="relative flex items-center" data-testid="comm-date">
              {selectedTab !== 1 && (
                <button
                  type="button"
                  onClick={handlePrevDate}
                  aria-label="Previous day"
                  className="flex h-8 w-7 items-center justify-center rounded-l-md border border-r-0 border-[#D0D5DD] bg-white text-[#475467] hover:bg-[#F8FAFC]"
                >
                  ‹
                </button>
              )}
              <button
                ref={calendarButtonRef}
                type="button"
                onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                title="Pick a day"
                className={`flex h-8 items-center gap-1.5 border border-[#D0D5DD] bg-white px-2 text-[13px] text-[#1D2951] hover:bg-[#F8FAFC] ${
                  selectedTab === 1 ? "rounded-md" : ""
                }`}
              >
                {selectedTab === 1 ? (
                  <span className="font-medium">
                    {dateRange.startDate.format("MM-DD-YYYY")} – {dateRange.endDate.format("MM-DD-YYYY")}
                  </span>
                ) : (
                  <>
                    <span className="text-[#667085]">
                      {!selectedDate
                        ? "All days"
                        : selectedDate.isSame(dayjs(), "day")
                          ? "Today"
                          : selectedDate.format("ddd")}
                    </span>
                    {selectedDate && <span className="font-medium">{selectedDate.format("MM-DD-YYYY")}</span>}
                  </>
                )}
                <span className="text-[#98A2B3] [&_svg]:h-4 [&_svg]:w-4">{actionDropDownCalenderIcon}</span>
              </button>
              {selectedTab !== 1 && (
                <button
                  type="button"
                  onClick={handleNextDate}
                  aria-label="Next day"
                  className="flex h-8 w-7 items-center justify-center rounded-r-md border border-l-0 border-[#D0D5DD] bg-white text-[#475467] hover:bg-[#F8FAFC]"
                >
                  ›
                </button>
              )}
              {isCalendarOpen && (
                <div ref={calendarRef} className="absolute left-0 top-[36px] z-50 rounded-xl bg-white shadow-lg">
                  {selectedTab === 1 ? (
                    <DateRangeSelector
                      selectedDateRange={{
                        startDate: dateRange.startDate.toDate(),
                        endDate: dateRange.endDate.toDate(),
                        key: "selection",
                      }}
                      setSelectedDateRange={(range) =>
                        setDateRange({
                          startDate: dayjs(range.startDate),
                          endDate: dayjs(range.endDate),
                        })
                      }
                      onSubmit={() => setIsCalendarOpen(false)}
                      handlereset={() =>
                        setDateRange({
                          startDate: dayjs(),
                          endDate: dayjs(),
                        })
                      }
                    />
                  ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="w-[300px]">
                        <CustomDateCalendar
                          value={selectedDate}
                          onChange={(date) => {
                            setSelectedDate(date);
                            setIsCalendarOpen(false);
                          }}
                        />
                      </div>
                    </LocalizationProvider>
                  )}
                </div>
              )}
            </div>
          )}
          {selectedTab !== 3 && selectedTab !== 4 && (
            <div className="flex min-w-[180px] max-w-sm flex-1 items-center gap-2">
              <div className="flex h-8 flex-1 items-center rounded-md border border-[#D0D5DD] bg-white">
                <FontAwesomeIcon icon={faSearch} className="ml-2.5 text-xs text-gray-400" />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="h-full min-w-0 flex-grow rounded-md bg-transparent pl-2 pr-2 text-[13px] outline-none"
                  aria-label="Search"
                  placeholder={
                    selectedTab === 1
                      ? "Search by sender or subject"
                      : selectedTab === 0
                        ? "Search by phone, sender, or document type"
                        : "Search by phone, name, or subject"
                  }
                />
              </div>
              {(searchTerm || selectedDate) && (
                <button
                  type="button"
                  className="flex shrink-0 items-center gap-1 text-[13px] text-[#667085] hover:text-[#1D2951]"
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedDate(null);
                  }}
                >
                  {reseticongray}
                  Reset
                </button>
              )}
            </div>
          )}
          {selectedTab === 0 && (
            <button
              type="button"
              onClick={() => setOpenSendFax(true)}
              className="ml-auto h-8 shrink-0 rounded-md border border-[#1D2951] bg-white px-3 text-[13px] font-medium text-[#1D2951] hover:bg-[#1D2951]/[0.06]"
            >
              Send Fax
            </button>
          )}
        </div>
        )}

        {/* Tables */}
        <div className="w-full flex justify-center">
          {selectedTab === 1 && (
            <EmailTable
              loading={loading}
              emails={emails}
              refresh={fetchemails}
            />
          )}
          {selectedTab === 2 && (
            <VoiceMailTable
              loading={loading}
              voicemails={filteredVoicemails}
              fetchVoicemail={fetchVoicemails}
            />
          )}
          {selectedTab === 0 && (
            <FaxTable
              fetchFax={fetchFax}
              loading={loading}
              fax={filteredFax}
              faxProviders={faxProviders}
              workAvailable={faxWorkAvailable}
              assign={faxAssign}
              deletedFax={filteredDeletedFax}
              deletedDays={deletedDays}
              deletedLoaded={deletedLoaded}
              fetchDeletedFax={fetchDeletedFax}
              all30Fax={filteredAll30Fax}
              all30Counts={all30Counts}
              all30Loaded={all30Loaded}
              fetchAll30Fax={fetchAll30Fax}
              inboxStyle={inboxFax}
              inboxToolbar={
                inboxFax
                  ? {
                      search: searchTerm,
                      setSearch: setSearchTerm,
                      selectedDate,
                      setSelectedDate,
                      onSendFax: () => setOpenSendFax(true),
                    }
                  : null
              }
            />
          )}
          {selectedTab === 3 && <Messaging onClose={() => setSelectedTab(firstTab)} />}
          {selectedTab === 4 && <WebRequestsTable type="appointment" />}
        </div>

        <SendFaxModal
          open={openSendFax}
          onClose={() => setOpenSendFax(false)}
        />
      </Shell>
    </div>
  );
};

export default Fax;
